// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreateRefundInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/create_refund
 *
 * Validates input for creating a refund request.
 * Note: pays_to is optional - controller forces it to user's sub for Operador role.
 */
import { registerContract } from './validate'

export interface Payroll_CreateRefundInput {
franchise_id: number
title: string
description: string
amount: number
expense_date: string
pays_to?: string
blob_name?: string
}

registerContract('Payroll_CreateRefundInput', {
  franchise_id: { type: 'number',  required: true },
  title:        { type: 'string',  required: true },
  description:  { type: 'string',  required: true },
  amount:       { type: 'number',  required: true },
  expense_date: { type: 'string',  required: true },
  pays_to:      { type: 'string',  required: false },
  blob_name:    { type: 'string',  required: false },
})
